var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"color":_vm.color,"buttonText":_vm.buttonText},nativeOn:{"click":function($event){$event.preventDefault();return _vm.clearLeaderboard.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }